import 'flex.box/src/flexbox.css'

import Vue from 'vue'
import App from './App.vue'

import './registerServiceWorker'
import router from './router'
import store from './store'
import { Button, Input, Tag, Toast } from 'buefy'
import 'buefy/dist/buefy.css'

/**
 * Plugins > Auth0
 */
import { Auth0Plugin, Auth0Config } from '@/plugins/auth'

/**
 * Plugins > Stripe
 */
import { StripePlugin } from '@/plugins/stripe'

/**
 * Plugins > Quagga
 */
import { QuaggaPlugin, QuaggaConfig } from '@/plugins/quagga'

/**
 * fortawesome
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBarcode, faArrowRight, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/**
 * vue-swiper
 */
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
import { faBarcodeRead, faReceipt, faQuestionCircle, faCamera, faPlusSquare, faMinusSquare, faCashRegister, faKey, faUser, faLockOpenAlt, faSpinner, faCctv } from '@fortawesome/pro-light-svg-icons'

library.add(
	faBarcode,
	faArrowRight,
	faCircleNotch
)
library.add(
	faBarcodeRead,
	faReceipt,
	faQuestionCircle,
	faCamera,
	faPlusSquare,
	faMinusSquare,
	faCashRegister,
	faKey,
	faUser,
	faLockOpenAlt,
	faSpinner,
	faCctv
)
// library.add(FaMapMarkerExclamation)

Vue.component('font-awesome-icon', FontAwesomeIcon)

/**
 * Install plugins and components
 */
Vue.use(Auth0Plugin, {
	domain: Auth0Config.domain,
	clientId: Auth0Config.clientId,
	onRedirectCallback: appState => {
		// console.log('appState', appState)
		const option = appState && appState.targetUrl
			? appState.targetUrl
			: '/main/cashier'
			// : window.location.pathname
		// console.log('option', option)
		router.push(option)
	}
})
Vue.use(StripePlugin, {
	key: process.env.VUE_APP_STRIPE_KEY
})
Vue.use(QuaggaPlugin, {
	store,
	config: QuaggaConfig
})

Vue.use(Button)
Vue.use(Input)
Vue.use(Tag)
Vue.use(Toast)

/**
 * vue-swiper
 */
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.$productsList = []

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
